<template>
  <div>
    <el-card>
      <!-- 搜索区域 -->
      <el-form ref="queryFormRef" class="queryFormClass" :model="queryForm">
        <el-row>
          <el-col :span="7">
            <el-form-item :label="$t('dictionary.dictionaryType') + '：'">
              <el-input v-model.trim="queryForm.params.dictType" clearable :placeholder="$t('dictionary.pleaseInput')" />
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item :label="$t('dictionary.dictionaryName') + '：'">
              <el-input v-model.trim="queryForm.params.dictName" clearable :placeholder="$t('dictionary.pleaseInput')" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-row type="flex" justify="start">
        <el-col :span="12">
          <div>
            <el-button
              type="primary" size="mini" icon="el-icon-search"
              @click="searchTableData"
            >
              {{ $t('dictionary.search') }}
            </el-button>
            <el-button icon="el-icon-refresh" size="mini" @click="queryFormReset">{{
              $t('dictionary.reset')
            }}
            </el-button>
            <el-button
              type="primary" size="mini" plain
              icon="el-icon-plus" @click="addDictType"
            >{{
              $t('dictionary.add')
            }}
            </el-button>
          </div>
        </el-col>
      </el-row>
      <el-divider />
    </el-card>
    <el-card style="margin-top: 20px">
      <!-- 表格区域 - 可滚动 -->
      <div>
        <el-table
          :data="tableData" style="width: 100%" height="500px"
          border @row-click="manageData"
        >
          <el-table-column
            prop="dictType" :label="$t('dictionary.dictionaryType')" min-width="180"
            align="center"
          />
          <el-table-column
            prop="dictName" :label="$t('dictionary.dictionaryName')" min-width="120"
            align="center"
          />
          <el-table-column
            prop="status" :label="$t('GlobalSetObj.status')" min-width="70"
            align="center"
          >
            <template slot-scope="scope">
              <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'" size="small">
                {{ scope.row.status === 1 ? $t('GlobalSetObj.enable') : $t('GlobalSetObj.disable') }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column :label="$t('dictionary.isSystem')" min-width="75" align="center">
            <template slot-scope="scope">
              <el-tag :type="scope.row.isSystem ? 'success' : 'info'" size="small">
                {{ scope.row.isSystem ? $t('dictionary.yes') : $t('dictionary.no') }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="remark" :label="$t('GlobalSetObj.remark')" min-width="140"
            align="center"
            show-overflow-tooltip
          />
          <el-table-column
            prop="createUserName" :label="$t('roleManage.creator')" align="center"
            min-width="90"
          />
          <el-table-column
            prop="createTime" :label="$t('dictionary.CreationTime')" min-width="145"
            align="center"
          />
          <el-table-column
            prop="updateUserName" :label="$t('roleManage.ModifiedBy')" align="center"
            min-width="90"
          />
          <el-table-column
            prop="updateTime" :label="$t('dictionary.ModificationTime')" min-width="145"
            align="center"
          />
          <el-table-column :label="$t('dictionary.operation')" align="center" width="70">
            <template slot-scope="scope">
              <div class="operationBtns">
                <el-tooltip :content="$t('dictionary.modify')" placement="top">
                  <el-button
                    type="text" icon="el-icon-edit" size="small"
                    :disabled="scope.row.isSystem"
                    @click.stop="putClick(scope.row)"
                  />
                </el-tooltip>
                <el-tooltip :content="$t('dictionary.manageData')" placement="top">
                  <el-button
                    type="text" icon="el-icon-s-operation" size="small"
                    @click.stop="manageData(scope.row)"
                  />
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="block">
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          :current-page.sync="queryForm.pageNumber"
          :page-sizes="[10, 20, 50, 100]"
          :page-size.sync="queryForm.pageSize"
          :total="total"
          background
          @size-change="getTableData"
          @current-change="getTableData"
        />
      </div>
    </el-card>
    <!-- DictType 详情/新增/修改 Drawer -->
    <el-drawer
      :title="drawerTitle" :visible.sync="drawerVisible" :direction="direction"
      size="500px"
    >
      <div class="drawerContent">
        <el-form
          ref="dictTypeFormRef" :label-position="labelPosition" label-width="120px"
          :model="dictTypeForm"
          :rules="dictTypeRules"
        >
          <el-form-item prop="dictType" :label="$t('dictionary.dictionaryType') + '：'">
            <el-input
              v-model="dictTypeForm.dictType" :disabled="isEdit || isDetail || isSystemDict"
              :placeholder="$t('dictionary.dictTypeKeyFormat')"
            />
          </el-form-item>
          <el-form-item prop="dictName" :label="$t('dictionary.dictionaryName') + '：'">
            <el-input
              v-model="dictTypeForm.dictName" :disabled="isDetail || isSystemDict"
              :placeholder="$t('dictionary.pleaseInput')"
            />
          </el-form-item>
          <el-form-item prop="status" :label="$t('GlobalSetObj.status') + '：'">
            <el-radio-group v-model="dictTypeForm.status" :disabled="isDetail || isSystemDict">
              <el-radio :label="1">{{ $t('GlobalSetObj.enable') }}</el-radio>
              <el-radio :label="0">{{ $t('GlobalSetObj.disable') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('GlobalSetObj.remark') + '：'">
            <el-input
              v-model="dictTypeForm.remark" type="textarea" :rows="3"
              :disabled="isDetail || isSystemDict"
              :placeholder="$t('dictionary.pleaseInput')"
            />
          </el-form-item>
        </el-form>
        <div v-if="!isDetail" class="drawerFooter">
          <el-button @click="drawerVisible = false">{{ $t('collectionCenter.cancel') }}</el-button>
          <el-button type="primary" @click="submitDictType">{{ $t('dictionary.submit') }}</el-button>
        </div>
      </div>
    </el-drawer>

    <!-- 字典数据管理 Drawer -->
    <el-drawer
      :title="dataDrawerTitle" :visible.sync="dataDrawerVisible" :direction="direction"
      size="85%"
    >
      <div class="drawerContent dataDrawerContent">
        <div class="dataManageHeader">
          <span class="dictTypeTag">{{ currentDictType }}</span>
          <el-button
            type="primary" size="mini" icon="el-icon-plus"
            @click="addDictData"
          >{{ $t('dictionary.add') }}</el-button>
        </div>
        <div class="dataTableArea">
          <el-table
            :data="dictDataTable" style="width: 100%;" border
            height="100%"
          >
            <el-table-column
              prop="dictValue" :label="$t('dictionary.dictionaryV')" min-width="110"
              align="center"
            />
            <el-table-column
              prop="dictLabel" :label="$t('dictionary.dictLabel')" min-width="110"
              align="center"
            />
            <el-table-column :label="$t('dictionary.multiLangConfig')" min-width="160" align="center">
              <template slot-scope="scope">
                <div class="langTags">
                  <el-tooltip :content="scope.row.dictLabelMap ? scope.row.dictLabelMap.zh || '-' : '-'" placement="top" :disabled="!(scope.row.dictLabelMap && scope.row.dictLabelMap.zh && scope.row.dictLabelMap.zh.length > 8)">
                    <span class="langTagText">{{ $t('dictionary.zhLang') }}: {{ scope.row.dictLabelMap ? scope.row.dictLabelMap.zh : '-' }}</span>
                  </el-tooltip>
                  <el-tooltip :content="scope.row.dictLabelMap ? scope.row.dictLabelMap.en || '-' : '-'" placement="top" :disabled="!(scope.row.dictLabelMap && scope.row.dictLabelMap.en && scope.row.dictLabelMap.en.length > 8)">
                    <span class="langTagText">{{ $t('dictionary.enLang') }}: {{ scope.row.dictLabelMap ? scope.row.dictLabelMap.en : '-' }}</span>
                  </el-tooltip>
                  <el-tooltip :content="scope.row.dictLabelMap ? scope.row.dictLabelMap.pu || '-' : '-'" placement="top" :disabled="!(scope.row.dictLabelMap && scope.row.dictLabelMap.pu && scope.row.dictLabelMap.pu.length > 8)">
                    <span class="langTagText">{{ $t('dictionary.puLang') }}: {{ scope.row.dictLabelMap ? scope.row.dictLabelMap.pu : '-' }}</span>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="remark" :label="$t('GlobalSetObj.remark')" min-width="100"
              align="center" show-overflow-tooltip
            />
            <el-table-column
              prop="sortOrder" :label="$t('dictionary.sortOrder')" width="70"
              align="center"
            />
            <el-table-column
              prop="status" :label="$t('GlobalSetObj.status')" width="75"
              align="center"
            >
              <template slot-scope="scope">
                <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'" size="small">
                  {{ scope.row.status === 1 ? $t('GlobalSetObj.enable') : $t('GlobalSetObj.disable') }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column :label="$t('dictionary.isSystem')" width="85" align="center">
              <template slot-scope="scope">
                <el-tag :type="scope.row.isSystem ? 'success' : 'info'" size="small">
                  {{ scope.row.isSystem ? $t('dictionary.yes') : $t('dictionary.no') }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column
              prop="createUserName" :label="$t('roleManage.creator')" align="center"
              min-width="100"
            />
            <el-table-column
              prop="createTime" :label="$t('dictionary.CreationTime')" min-width="150"
              align="center"
            />
            <el-table-column
              prop="updateUserName" :label="$t('roleManage.ModifiedBy')" align="center"
              min-width="100"
            />
            <el-table-column
              prop="updateTime" :label="$t('dictionary.ModificationTime')" min-width="150"
              align="center"
            />
            <el-table-column :label="$t('dictionary.operation')" width="60" align="center">
              <template slot-scope="scope">
                <div class="operationBtns">
                  <el-tooltip :content="$t('dictionary.edit')" placement="top">
                    <el-button
                      type="text" icon="el-icon-edit" size="small"
                      :disabled="scope.row.isSystem" @click.stop="editDictData(scope.row)"
                    />
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="block">
          <el-pagination
            layout="total, sizes, prev, pager, next"
            :current-page.sync="dictDataQuery.pageNumber"
            :page-sizes="[10, 20, 50]"
            :page-size.sync="dictDataQuery.pageSize"
            :total="dictDataTotal"
            background
            @size-change="onDictDataSizeChange"
            @current-change="onDictDataPageChange"
          />
        </div>
      </div>
    </el-drawer>

    <!-- 字典数据 新增/编辑 Drawer -->
    <el-drawer
      :title="dataFormTitle" :visible.sync="dataFormVisible" :direction="direction"
      size="500px"
    >
      <div class="drawerContent">
        <el-form
          ref="dictDataFormRef" :label-position="labelPosition" label-width="120px"
          :model="dictDataForm"
          :rules="dictDataRules"
        >
          <el-form-item prop="dictValue" :label="$t('dictionary.dictionaryValue') + '：'">
            <el-input
              v-model="dictDataForm.dictValue" :disabled="dataEditId !== null"
              :placeholder="$t('dictionary.pleaseInput')"
            />
          </el-form-item>
          <el-form-item prop="dictLabel" :label="$t('dictionary.dictLabel') + '：'">
            <el-input v-model="dictDataForm.dictLabel" :placeholder="$t('dictionary.pleaseInput')" />
          </el-form-item>
          <el-form-item prop="sortOrder" :label="$t('dictionary.sortOrder') + '：'">
            <el-input-number v-model="dictDataForm.sortOrder" :min="0" :max="9999" />
          </el-form-item>
          <el-form-item :label="$t('GlobalSetObj.status') + '：'">
            <el-radio-group v-model="dictDataForm.status">
              <el-radio :label="1">{{ $t('GlobalSetObj.enable') }}</el-radio>
              <el-radio :label="0">{{ $t('GlobalSetObj.disable') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('GlobalSetObj.remark') + '：'">
            <el-input
              v-model="dictDataForm.remark" type="textarea" :rows="2"
              :placeholder="$t('dictionary.pleaseInput')"
            />
          </el-form-item>
          <!-- 多语言配置 -->
          <el-divider content-position="left">{{ $t('dictionary.multiLangConfig') }}</el-divider>
          <el-form-item :label="$t('dictionary.zhLang') + '：'">
            <el-input v-model="dictDataForm.dictLabelMap.zh" :placeholder="$t('dictionary.pleaseInput')" />
          </el-form-item>
          <el-form-item :label="$t('dictionary.enLang') + '：'">
            <el-input v-model="dictDataForm.dictLabelMap.en" :placeholder="$t('dictionary.pleaseInput')" />
          </el-form-item>
          <el-form-item :label="$t('dictionary.puLang') + '：'">
            <el-input v-model="dictDataForm.dictLabelMap.pu" :placeholder="$t('dictionary.pleaseInput')" />
          </el-form-item>
        </el-form>
        <div class="drawerFooter">
          <el-button @click="dataFormVisible = false">{{ $t('collectionCenter.cancel') }}</el-button>
          <el-button type="primary" @click="submitDictData">{{ $t('dictionary.submit') }}</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { dictTypePage, dictTypeSave, dictTypeDelete } from '@/api/newDict';
import { dictDataPage, dictDataSave, dictDataDelete } from '@/api/newDict';

export default {
  name: 'NewDictType',
  data() {
    return {
      direction: 'rtl',
      labelPosition: 'right',

      // 查询表单
      queryForm: {
        pageNumber: 1,
        pageSize: 10,
        params: {
          dictType: '',
          dictName: ''
        }
      },
      tableData: [],
      total: 0,

      // DictType Drawer
      drawerVisible: false,
      drawerTitle: '',
      isEdit: false,
      isDetail: false,
      isSystemDict: false,
      editId: null,
      dictTypeForm: {
        dictType: '',
        dictName: '',
        status: 1,
        remark: ''
      },
      dictTypeRules: {
        dictType: [
          { required: true, message: this.$t('dictionary.notNull'), trigger: 'blur' },
          { pattern: /^[a-z][a-z0-9_]*$/, message: this.$t('dictionary.dictTypeKeyFormat'), trigger: 'blur' }
        ],
        dictName: [
          { required: true, message: this.$t('dictionary.notNull'), trigger: 'blur' }
        ]
      },

      // DictData 管理 Drawer
      dataDrawerVisible: false,
      dataDrawerTitle: '',
      currentDictType: '',
      dictDataTable: [],
      dictDataQuery: {
        pageNumber: 1,
        pageSize: 10,
        params: { dictType: '' },
        needCount: true
      },
      dictDataTotal: 0,

      // DictData 新增/编辑 Drawer
      dataFormVisible: false,
      dataFormTitle: '',
      isDataSystem: false,
      dataEditId: null,
      dictDataForm: {
        dictType: '',
        dictValue: '',
        dictLabel: '',
        dictLabelMap: { zh: '', en: '', pu: '' },
        sortOrder: 0,
        isDefault: false,
        isSystem: false,
        status: 1,
        remark: ''
      },
      dictDataRules: {
        dictValue: [
          { required: true, message: this.$t('dictionary.notNull'), trigger: 'blur' }
        ],
        dictLabel: [
          { required: true, message: this.$t('dictionary.notNull'), trigger: 'blur' }
        ]
      }
    };
  },
  computed: {
    dataTableHeight() {
      return window.innerHeight - 180;
    }
  },
  created() {
    this.getTableData();
  },
  mounted() {
    this.$el.parentElement.style.overflow = 'hidden';
  },
  beforeDestroy() {
    this.$el.parentElement.style.overflow = '';
  },
  methods: {
    // ===================== DictType 列表 =====================
    getTableData() {
      dictTypePage(this.queryForm).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.total = res.data.total;
        }
      }).catch(() => {
      });
    },
    searchTableData() {
      this.queryForm.pageNumber = 1;
      this.getTableData();
    },
    queryFormReset() {
      this.queryForm.params.dictType = '';
      this.queryForm.params.dictName = '';
      this.getTableData();
    },

    // ===================== DictType 操作 =====================
    addDictType() {
      this.isEdit = false;
      this.isDetail = false;
      this.isSystemDict = false;
      this.editId = null;
      this.drawerTitle = this.$t('dictionary.add');
      this.drawerVisible = true;
      this.dictTypeForm = {
        dictType: '',
        dictName: '',
        status: 1,
        remark: ''
      };
      this.$nextTick(() => {
        this.$refs.dictTypeFormRef && this.$refs.dictTypeFormRef.clearValidate();
      });
    },
    putClick(row) {
      this.isEdit = true;
      this.isDetail = false;
      this.isSystemDict = row.isSystem;
      this.editId = row.id;
      this.drawerTitle = this.$t('dictionary.modify');
      this.drawerVisible = true;
      this.dictTypeForm = {
        dictType: row.dictType,
        dictName: row.dictName,
        status: row.status,
        remark: row.remark || ''
      };
      this.$nextTick(() => {
        this.$refs.dictTypeFormRef && this.$refs.dictTypeFormRef.clearValidate();
      });
    },
    submitDictType() {
      this.$refs.dictTypeFormRef.validate((valid) => {
        if (!valid) return;
        const params = {
          id: this.isEdit ? this.editId : null,
          dictName: this.dictTypeForm.dictName,
          dictType: this.dictTypeForm.dictType,
          status: this.dictTypeForm.status,
          remark: this.dictTypeForm.remark
        };
        dictTypeSave(params).then(res => {
          if (res.code === 200) {
            this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
            this.drawerVisible = false;
            this.getTableData();
          }
        }).catch(() => {
        });
      });
    },
    deleteDictType(row) {
      if (row.isSystem) {
        this.$message.warning(this.$t('dictionary.systemCannotDelete'));
        return;
      }
      this.$confirm(this.$t('dictionary.confirmDelete'), this.$t('collectionCenter.tips'), {
        confirmButtonText: this.$t('collectionCenter.confirm'),
        cancelButtonText: this.$t('collectionCenter.cancel'),
        type: 'warning'
      }).then(() => {
        dictTypeDelete(row.id).then(res => {
          if (res.code === 200) {
            this.$message.success(this.$t('GlobalSetObj.DeleteSuccessful'));
            this.getTableData();
          }
        }).catch(() => {
        });
      }).catch(() => {
      });
    },

    // ===================== DictData 管理 =====================
    manageData(row) {
      this.currentDictType = row.dictType;
      this.dataDrawerTitle = this.$t('dictionary.dictDataManage') + ' - ' + row.dictName;
      this.dictDataQuery.params.dictType = row.dictType;
      this.dictDataQuery.pageNumber = 1;
      this.dictDataQuery.pageSize = 10;
      this.dataDrawerVisible = true;
      this.loadDictData();
    },
    loadDictData() {
      dictDataPage(this.dictDataQuery).then(res => {
        if (res.code === 200) {
          this.dictDataTable = res.data.records;
          this.dictDataTotal = res.data.total;
        }
      }).catch(() => {});
    },
    onDictDataSizeChange() {
      this.dictDataQuery.pageNumber = 1;
      this.loadDictData();
    },
    onDictDataPageChange() {
      this.loadDictData();
    },
    addDictData() {
      this.isDataSystem = false;
      this.dataEditId = null;
      this.dataFormTitle = this.$t('dictionary.add') + ' - ' + this.currentDictType;
      this.dataFormVisible = true;
      this.dictDataForm = {
        dictType: this.currentDictType,
        dictValue: '',
        dictLabel: '',
        dictLabelMap: { zh: '', en: '', pu: '' },
        sortOrder: 0,
        isDefault: false,
        isSystem: false,
        status: 1,
        remark: ''
      };
      this.$nextTick(() => {
        this.$refs.dictDataFormRef && this.$refs.dictDataFormRef.clearValidate();
      });
    },
    editDictData(row) {
      this.isDataSystem = row.isSystem;
      this.dataEditId = row.id;
      this.dataFormTitle = this.$t('dictionary.edit') + ' - ' + this.currentDictType;
      this.dataFormVisible = true;
      this.dictDataForm = {
        dictType: row.dictType,
        dictValue: row.dictValue,
        dictLabel: row.dictLabel,
        dictLabelMap: row.dictLabelMap ? { zh: row.dictLabelMap.zh || '', en: row.dictLabelMap.en || '', pu: row.dictLabelMap.pu || '' } : { zh: '', en: '', pu: '' },
        sortOrder: row.sortOrder || 0,
        isDefault: row.isDefault || false,
        isSystem: row.isSystem || false,
        status: row.status,
        remark: row.remark || ''
      };
      this.$nextTick(() => {
        this.$refs.dictDataFormRef && this.$refs.dictDataFormRef.clearValidate();
      });
    },
    submitDictData() {
      this.$refs.dictDataFormRef.validate((valid) => {
        if (!valid) return;
        const params = {
          id: this.dataEditId,
          dictType: this.dictDataForm.dictType,
          dictValue: this.dictDataForm.dictValue,
          dictLabel: this.dictDataForm.dictLabel,
          dictLabelMap: this.dictDataForm.dictLabelMap,
          sortOrder: this.dictDataForm.sortOrder,
          isDefault: this.dictDataForm.isDefault,
          isSystem: this.dictDataForm.isSystem,
          status: this.dictDataForm.status,
          remark: this.dictDataForm.remark
        };
        dictDataSave(params).then(res => {
          if (res.code === 200) {
            this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
            this.dataFormVisible = false;
            this.loadDictData();
          }
        }).catch(() => {
        });
      });
    },
    deleteDictData(row) {
      if (row.isSystem) {
        this.$message.warning(this.$t('dictionary.systemDataCannotDelete'));
        return;
      }
      this.$confirm(this.$t('dictionary.confirmDeleteData'), this.$t('collectionCenter.tips'), {
        confirmButtonText: this.$t('collectionCenter.confirm'),
        cancelButtonText: this.$t('collectionCenter.cancel'),
        type: 'warning'
      }).then(() => {
        dictDataDelete(row.id).then(res => {
          if (res.code === 200) {
            this.$message.success(this.$t('GlobalSetObj.DeleteSuccessful'));
            this.loadDictData();
          }
        }).catch(() => {
        });
      }).catch(() => {
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.newDictBox {
  padding: 20px;
  box-sizing: border-box;
  height: calc(100vh - 90px); /* 减去可能的顶部导航高度 */
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.searchArea {
  flex-shrink: 0; /* 搜索区域不收缩 */
}

.queryFormClass ::v-deep .el-form-item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.queryFormClass ::v-deep .el-form-item__label {
  padding: 0;
  line-height: 16px;
  white-space: nowrap;
  margin-left: 20px;
}

.tableContainer {
  flex: 1;
  overflow: hidden;
  margin-bottom: 10px;
  min-height: 0;
}

.tableContainer ::v-deep .el-table {
  height: 95%;
}

.tableContainer ::v-deep .el-table__body-wrapper {
  overflow-y: auto !important;
}

.block {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-shrink: 0; /* 分页区域不收缩 */
  padding-top: 10px;
}

.drawerContent {
  padding: 20px;
  box-sizing: border-box;
}

.drawerContent ::v-deep .el-select {
  width: 100%;
}

.drawerFooter {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 40px;
}

.dataDrawerContent {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.dataManageHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  padding-bottom: 16px;
}

.dataTableArea {
  flex: 1;
  overflow: hidden;
  min-height: 0;
}

.dictTypeTag {
  font-size: 14px;
  font-weight: bold;
  color: #409EFF;
}

.langTags {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}

.langTagText {
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0 5px;
  line-height: 20px;
  font-size: 12px;
  background: #f0f2f5;
  border: 1px solid #e4e7ed;
  border-radius: 3px;
  color: #909399;
  cursor: default;
}

.operationBtns {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}

.newDictBox ::v-deep .el-drawer__body {
  overflow: hidden;
}
</style>
